let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cdXMO")).then(() => parcelRequire('7Nsl3'));